// Foundations
import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';

// Services
import { AnalyticsService } from '@app/services/analytics.service';
import { MyProfileService } from '@app/services/my-profile.service';

// Components
import { VetLocationSearchSelectComponent } from '@app/components/_share/vet-location-search-select/vet-location-search-select.component';

// Models
import { ParsedVet } from '@app/models/pet/vet.model';

@Component({
  selector: 'app-search-preferred-vet',
  templateUrl: './search-preferred-vet.component.html',
  styleUrls: ['./search-preferred-vet.component.scss'],
})
export class SearchPreferredVetComponent implements OnInit {
  @Output() showEditPreferredVet = new EventEmitter<ParsedVet>();

  @ViewChild('searchSelect', { static: false })
  searchSelect: VetLocationSearchSelectComponent;

  selectedVetId: number;
  isBtnEnabled = false;

  constructor(private _analytics: AnalyticsService) {}

  ngOnInit(): void {}

  cancelSelect(): void {
    this.showEditPreferredVet.emit();
  }

  onConfirmSelect(): void {
    this._analytics.logButtonTap('dogProfile_saveLocalVet');
    this.showEditPreferredVet.emit(this.searchSelect.currentSelection);
  }

  handleSelectedCampId(id: number): void {
    this.isBtnEnabled = !!id;
    this.selectedVetId = id;
  }
}
